// UserProfileShow.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AddIcon from "@mui/icons-material/Add";

export const UserProfileShow = () => {
  const [userProfiles, setUserProfiles] = useState([]);
  const [deleteUserProfileId, setDeleteUserProfileId] = useState(null);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getAllUserProfiles = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/userinfo`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setUserProfiles(data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleCreateNewUser = () => {
    navigate("/userprofiles/create");
  };
  const handleDeleteUserProfile = async () => {
    const userProfileId = deleteUserProfileId;
    console.log(
      `${process.env.REACT_APP_BACKEND_URL}/blogs/userinfo/delete/${userProfileId}`
    );
    try {
      // Perform the delete operation using the userProfileId
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/userinfo/delete/${userProfileId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      handleCloseDeleteDialog();
      // Refresh the userProfile list
      getAllUserProfiles();
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenDeleteDialog = (userProfileId) => {
    setDeleteUserProfileId(userProfileId);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteUserProfileId(null);
  };

  useEffect(() => {
    getAllUserProfiles();
  }, []);

  return (
    <div>
      <div
        style={{ fontSize: "2rem", fontWeight: "500", marginBottom: "1rem" }}
      >
        User Data:
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "gainsboro" }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>

              <TableCell>Is Google Signup</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userProfiles.map((userProfile) => (
              <TableRow key={userProfile._id}>
                <TableCell>{userProfile._id}</TableCell>
                <TableCell>{userProfile.name}</TableCell>
                <TableCell>{userProfile.email}</TableCell>

                <TableCell>{userProfile.isGoogleSignup.toString()}</TableCell>
                <TableCell>
                  <Button
                    component={Link}
                    to={`/userprofiles/${userProfile._id}`}
                    variant="contained"
                    color="primary"
                  >
                    <VisibilityIcon />
                  </Button>
                  <Button
                    component={Link}
                    to={`/userprofiles/${userProfile._id}/edit`}
                    variant="contained"
                    color="warning"
                  >
                    <EditIcon />
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleOpenDeleteDialog(userProfile._id)}
                  >
                    <DeleteIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this user profile?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteUserProfile} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
